import { useState, useRef, useEffect } from "react";

const AutoFitTextDiv = (props) => {
  const textsize = props.textsize ? props.textsize : 25;
  const text = props.text ? props.text : "";
  const textAlign = props.textAlign ? props.textAlign : "left";

  const myRef = useRef(null);
  const [fontsize, setFontsize] = useState(textsize);

  useEffect(() => {
    // console.log(myRef.current.scrollHeight);
    // console.log(myRef.current.clientHeight);
    // console.log(myRef.current.scrollWidth);
    // console.log(myRef.current.clientWidth);
    let actualheight = myRef.current.scrollHeight;
    let divheight = myRef.current.clientHeight;
    let actualwidth = myRef.current.scrollWidth;
    let divwidth = myRef.current.clientWidth;

    if (fontsize > 1) {
      if (actualwidth > divwidth) {
        setFontsize(fontsize - 1);
      }

      if (actualheight > divheight) {
        setFontsize(fontsize - 1);
      }
    }
  }, [fontsize, text]);
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          fontSize: fontsize,
          textAlign: textAlign,
        }}
        ref={myRef}
      >
        <div></div>

        <div>{text}</div>
        <div></div>
      </div>
    </div>
  );
};

export default AutoFitTextDiv;
